<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container
          grid-list-xs
          fluid
          class="mb-0 pb-0 pt-2"
          style="padding: 5px;"
        >
          <v-card-title style="padding: 0;">
            <search-field @search="search"></search-field>
            <v-spacer></v-spacer>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="primary"
                slot="activator"
                @click="downloadPDF"
                style="margin-top: 10px;"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z"
                  />
                </svg>
              </v-btn>
              <span>Download PDF</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="primary"
                slot="activator"
                @click="downloadTemplate()"
                style="margin-top: 10px;"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>

            <v-btn
              fab
              dark
              small
              color="primary"
              @click="getData"
              style="margin-top: 10px;"
            >
              <v-icon dark>play_arrow</v-icon>
            </v-btn>

            <v-container style="padding-bottom: 0;" fluid>
              <v-layout wrap class="pa-0">
                <v-flex md2 style="padding: 0 5px;">
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFrom"
                      label="Ticket Date From"
                      prepend-inner-icon="event"
                      outline
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="dateFrom"
                      :max="dateTo"
                      min="1950-01-01"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md2 style="padding: 0 5px;">
                  <v-menu
                    ref="menu1"
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateTo"
                      label="Ticket Date To"
                      prepend-inner-icon="event"
                      outline
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="dateTo"
                      :max="new Date().toISOString().substr(0, 10)"
                      :min="dateFrom"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex md2 style="padding: 0 5px;">
                  <v-select
                    v-model="filterType"
                    :items="filterTypes"
                    label="Ticket Type"
                    outline
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-container>

        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.reference_no }}</td>
            <td class="text-xs-left">
              {{ props.item.transaction_no ? props.item.transaction_no : "--" }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.vehicle_type ? props.item.vehicle_type : "--" }}
            </td>

            <td class="text-xs-left text-uppercase text-no-wrap">
              {{ props.item.destination ? props.item.destination : "--" }}
            </td>
            <td class="text-xs-right">{{ props.item.km_post }}</td>
            <td class="text-xs-right">{{ props.item.amount.toFixed(2) }}</td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.route ? props.item.route : "--" }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.cashier ? props.item.cashier : "--" }}
            </td>
            <td class="text-xs-left">
              {{ props.item.ticket_type ? props.item.ticket_type : "--" }}
            </td>

            <td class="text-xs-left text-uppercase">
              {{
                props.item.validation_status
                  ? props.item.validation_status
                  : "--"
              }}
            </td>

            <td class="text-xs-center">
              {{
                props.item.created_at
                  ? $dateFormat(props.item.created_at, "YYYY-MM-DD")
                  : "--"
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.created_at
                  ? $dateFormat(props.item.created_at, "HH:mm:ss")
                  : "--"
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.departure_datetime
                  ? $dateFormat(props.item.departure_datetime, "YYYY-MM-DD")
                  : "--"
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.departure_datetime
                  ? $dateFormat(props.item.departure_datetime, "HH:mm")
                  : "--"
              }}
            </td>
          </template>
          <template slot="footer">
            <td class="text-xs-center"></td>
            <td class="text-xs-left">
              <strong>Total</strong>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-no-wrap text-xs-right">
              {{ totalFinalFare.toFixed(2) }}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import JsPdf from "jspdf";
import "jspdf-autotable";
// import DetailsContainer from "@/components/details_container/RemittanceDetailsContainer";
import XLSX from "xlsx";
var jsonexport = require("jsonexport");
var now = new Date();

export default {
  data() {
    return {
      title: "Ticket List",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Reference No.",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Transaction No.",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Vehicle Type",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Destination",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Post",
          align: "right",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: true,
        },
        {
          text: "Route",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Cashier",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Ticket Type",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Validation Status",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Date Created",
          align: "center",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Time Created",
          align: "center",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Departure Date",
          align: "center",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Departure Time",
          align: "center",
          value: "created_at",
          sortable: true,
        },
      ],
      vehicleHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
      ],
      items: [],
      vehicleItems: [],
      queryParams: {
        search: "",
        company_id: null,
        sub_company_id: null,
        transaction_id: null,
        type: null,
      },
      dialogType: "",
      dialogColor: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      subcompanies: [],
      vehicleTypes: [],
      filterTypes: [
        {
          text: "BOOK",
          value: 1,
        },
        {
          text: "REBOOK",
          value: 2,
        },
        {
          text: "CANCEL",
          value: 3,
        },
        {
          text: "REFUND",
          value: 4,
        },
        {
          text: "REPRINT",
          value: 5,
        },
        {
          text: "BAGGAGE",
          value: 6,
        },
      ],
      filterType: null,
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      downLoading: false,
      totalFinalFare: 0,
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {},
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;
      this.queryParams.type = this.filterType;

      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getTicketList(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        this.totalFinalFare = response.total_amount ? response.total_amount : 0;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async getProjects() {
      // Start Loading
      this.assignItems = [];
      const response = this.$store.state.subcompany;

      this.assignItems = response.projects;
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getVehicle(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
        data.city = data.city ? data.city.toUpperCase() : "";
        data.province = data.province ? data.province.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const items = (await Services.getSubCompanies({
        company_id: this.$store.state.company.id,
      })).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.subcompanies.push(data);
      }
    },
    async setVehicleTypes() {
      this.vehicleTypes = [];
      const items = (await Services.getVehicleTypes({
        company_id: this.$store.state.company.id,
      })).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.vehicleTypes.push(data);
      }
    },
    async setVehicles() {
      this.vehicleItems = [];
      this.vehicleItems = (await Services.getVehiclesUnassignedProject({
        company_id: this.$store.state.company.id,
        sub_company_id: this.$store.state.subcompany.id,
        project_id: this.$store.state.project.id,
      })).data;
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setVehicles();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;
      this.dialogColor = "green";
      this.dialogType = "edit";
      this.dialogStatus = true;

      //   await this.setSubCompanies();
      //   await this.setVehicleTypes();

      //   this.viewData = await this.setData(data.id);
      this.viewData = await data;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      if (this.$refs.form.validate()) {
        this.openConfirmDialog = true;
      }
    },
    async saveConfirmedAddDialog() {
      this.confirmLoading = true;

      const vehicles = this.selected.map((vehicle) => {
        return {
          id: vehicle.id,
        };
      });

      const body = {
        vehicles: vehicles,
        project_id: this.$store.state.project.id,
      };
      try {
        const response = await Services.assignVehicletoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAddDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Vehicle(s) has been added",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          amount_received: data.amount_received,
          status: 2,
        };
      try {
        const response = await Services.updateRemittance(data.id, body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Vehicle has been updated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteVehicle(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Vehicle has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.vehicleItems.slice();
    },
    async openSubscribeDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "assign";
      this.subscribeDialog = true;
      this.viewData = data;

      this.viewData = await this.setData(data.id);
      this.assignedItems = await this.viewData.projects;
      await this.getProjects();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeSubscribeDialog() {
      this.selected = [];
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogType = "";
      this.subscribeDialog = false;
    },
    saveSubscribeDialog() {
      this.openConfirmDialog = true;
    },
    notSubscribe(data) {
      for (var e = 0; e < this.assignedItems.length; e++) {
        if (this.assignedItems[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    showSubcribe(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    subscribeToProject(data) {
      this.selected.push(data);
    },
    unsubscribeToProject(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          this.selected.splice(e, 1);
        }
      }
    },
    async saveConfirmedSubscribeDialog() {
      this.confirmLoading = true;

      const projects = this.selected.map((project) => {
        return {
          id: project.id,
        };
      });
      const body = {
        projects: projects,
        vehicle_id: this.viewData.id,
      };
      try {
        const response = await Services.assignVehicletoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeSubscribeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Project/s has been assigned to Vehicle!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    refreshTable() {
      this.getData();
    },
    async downloadTemplate() {
      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();

      dataToDownload.push(header);

      this.items.forEach((item) => {
        let theItem = [];

        theItem.push(item.reference_no),
          theItem.push(item.transaction_no ? item.transaction_no : ""),
          theItem.push(
            item.vehicle_type ? item.vehicle_type.toUpperCase() : ""
          ),
          theItem.push(item.destination ? item.destination.toUpperCase() : ""),
          theItem.push(item.km_post),
          theItem.push(item.amount),
          theItem.push(item.route ? item.route.toUpperCase() : ""),
          theItem.push(item.cashier ? item.cashier.toUpperCase() : ""),
          theItem.push(item.ticket_type ? item.ticket_type : ""),
          theItem.push(item.validation_status ? item.validation_status : ""),
          theItem.push(
            item.created_at
              ? this.$dateFormat(item.created_at, "YYYY-MM-DD")
              : ""
          ),
          theItem.push(
            item.created_at ? this.$dateFormat(item.created_at, "HH:mm") : ""
          ),
          theItem.push(
            item.departure_datetime
              ? this.$dateFormat(item.departure_datetime, "YYYY-MM-DD")
              : ""
          ),
          theItem.push(
            item.departure_datetime
              ? this.$dateFormat(item.departure_datetime, "HH:mm")
              : ""
          ),
          dataToDownload.push(theItem);
      });

      let blankColumns = [];

      blankColumns.push("", "", "", "", "", "", "", "", "", "", "", "");

      dataToDownload.push(blankColumns);

      let theTotal = [];

      theTotal.push(
        "Total",
        "",
        "",
        "",
        "",
        this.totalFinalFare,
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );

      dataToDownload.push(theTotal);

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;

          if (header[C] === "POST") ws[ref].z = "#,##0";
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },

    downloadPDF() {
      var doc = new JsPdf("l", "pt", "a4");

      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text(this.$store.state.subcompany.name.toUpperCase(), 360, 40, {
        align: this.$store.state.subcompany.name.length > 11 ? "center" : "",
      });
      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text("TICKET LIST REPORT", 335, 60);
      doc.setFontSize(12);
      doc.setFontType("bold");

      this.dateFrom === this.dateTo
        ? doc.text("Date From & Date To: " + this.dateTo, 320, 80)
        : doc.text(
            "Date From: " + this.dateFrom + " " + "Date To: " + this.dateTo,
            290,
            80
          );

      let headers = [
        [
          "Reference No.",
          "Transaction No.",
          "Vehicle Type",
          "Destination",
          "Post",
          "Amount",
          "Route",
          "Cashier",
          "Ticket Type",
          "Validation Status",
          "Date Created",
          "Time Created",
          "Departure Date",
          "Departure Time",
        ],
      ];
      let data = [];

      this.items.forEach((item) => {
        let theData = [
          item.reference_no,
          item.transaction_no ? item.transaction_no : "",
          item.vehicle_type ? item.vehicle_type.toUpperCase() : "",
          item.destination ? item.destination.toUpperCase() : "",
          item.km_post,
          item.amount,
          item.route ? item.route.toUpperCase() : "",
          item.cashier ? item.cashier.toUpperCase() : "",
          item.ticket_type ? item.ticket_type : "",
          item.validation_status ? item.validation_status : "",
          item.created_at
            ? this.$dateFormat(item.created_at, "YYYY-MM-DD")
            : "",
          item.created_at ? this.$dateFormat(item.created_at, "HH:mm") : "",
          item.departure_datetime
            ? this.$dateFormat(item.departure_datetime, "YYYY-MM-DD")
            : "",
          item.departure_datetime
            ? this.$dateFormat(item.departure_datetime, "HH:mm")
            : "",
        ];
        data.push(theData);
      });

      doc.autoTable({
        head: headers,
        body: data,
        foot: [
          [
            "",
            "Total:",
            "",
            "",
            "",
            this.numberWithCommas(this.totalFinalFare),
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ],
        ],
        startY: 100,
        margin: {
          left: 15,
        },
        theme: "grid",
        tableWidth: 815,
        cellWidth: "wrap",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1,
        },
        footStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1,
          fontSize: 8,
          halign: "right",
        },
        showHead: "everyPage",
        showFoot: "lastPage",
        tableLineColor: 200,
        tableLineWidth: 0,
        columnStyles: {
          0: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
          2: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          3: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          4: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          5: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          6: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          7: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          8: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          9: {
            cellWidth: "auto",
            lineColor: "black",
            halign: "center",
            textColor: [0, 0, 0],
          },
          10: {
            cellWidth: "auto",
            halign: "center",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          11: {
            cellWidth: "auto",
            halign: "center",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          12: {
            cellWidth: "auto",
            halign: "center",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
        },
        styles: {
          overflow: "linebreak",
          cellWidth: "wrap",
          fontSize: 7,
        },
      });
      let pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i < pageCount; i++) {
        doc.setFontType("normal");
        doc.setFontSize(10);
        doc.setPage(i);
        doc.text(
          395,
          580,
          "Page" +
            " " +
            doc.internal.getCurrentPageInfo().pageNumber +
            " " +
            "of" +
            " " +
            pageCount
        );
      }
      doc.save(this.title + ".pdf");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}

.clsScroll {
  width: auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
